.messageContainer {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  display: flex;
  justify-content: center;
}
.message {
  background-color: var(--theme-inverted-background);
  color: var(--theme-inverted-primary-text);
  padding: 12px;
  border-radius: 4px;
  z-index: 100000; /* In front of everything */
  font-size: var(--default-font-size);
  min-width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: auto;
  gap: 8px;
  box-shadow: var(--theme-shadow-shallow);
}
.success {
  background-color: var(--theme-alert-success-background);
  color: var(--theme-alert-success-text);
  border-color: var(--theme-alert-success-border);
}
.error {
  background-color: var(--theme-alert-danger-background);
  border-color: var(--theme-alert-danger-border);
  color: var(--theme-alert-danger-text);
}
.message aha-button:first-of-type {
  margin-left: 16px;
}
.message p {
  margin: 0;
}
.message a {
  color: var(--theme-inverted-link-text);
}
